var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableCell',{staticClass:"action-cell",attrs:{"hSpan":_vm.hSpan}},[_vm._t("default"),_c('i',{staticClass:"material-icons"},[_vm._v("keyboard_arrow_right")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }